import React = require('react');

interface IHobbiesProps {
    items:Array<IItem>
    itemChangeHandler:Function
    viewMode:boolean
}

export interface IItem{
	name:string;
}

interface IHobbiesState {
}

export class Hobbies extends React.Component<IHobbiesProps, IHobbiesState>{

  	constructor(props:IHobbiesProps){
        super(props);
    }

	private getEmpty():IItem{
		return {
			name: ''
		};
	}

	private addNewRowHandler(evt): void {
		evt.preventDefault();
		var items = this.props.items;
		var newItem:IItem = this.getEmpty();
		if (  items.indexOf(newItem) === -1 ) {
			items.push(newItem);
			this.props.itemChangeHandler(items);
		}
	}

	private itemChangeHandler(evt, item:IItem, field:string): void {
		evt.preventDefault();
		var items = this.props.items;
		var currentIndex:number = items.indexOf(item);
		items[currentIndex][field] = evt.target.value;
		this.props.itemChangeHandler(items);
	}

    render() {
        return (
            <div className="moreItems">
				<div className="list">
					{
						this.props.items.map((item:IItem, key) => {
                             if (this.props.viewMode === true) {
                                return <div key={key}>
                                    { item.name }
                                </div>
                            }
							return <div className="row" key={key}>
								<input type="text" value={ item.name } placeholder="Hobbi neve" onChange={ e => this.itemChangeHandler(e, item, 'name') } />
							</div>
						})
					}
				</div>
				{ this.props.viewMode === false?<div className="row col3">
					<div className="box"></div>
					<div className="box"></div>
					<div className="box right">
						<button className="btn addBtn" onClick={ e => this.addNewRowHandler(e) }> + Új sor</button>
					</div>
				</div>:'' }
			</div>
        );
    }
}



// WEBPACK FOOTER //
// ./components/edit_item/Hobbies.tsx